import { RoleInterface } from "./RoleInterface";

import { Admin } from "./Roles/Admin";
import { None } from "./Roles/None";
import { Owner } from "./Roles/Owner";
import { Tenant } from "./Roles/Tenant";
import { User } from "./Roles/User";
import { Vendor } from "./Roles/Vendor";
import { Occupant } from "./Roles/Occupant";

class RoleContainer {

  private roles = [
    None,
    Tenant,
    Occupant,
    Owner,
    Vendor,
    User,
    Admin
  ];

  private instances = [
    new None(),
    new Tenant(),
    new Occupant(),
    new Owner(),
    new Vendor(),
    new User(),
    new Admin()
  ];

  public getRoles() {
    return this.roles;
  }

  public getInstances() {
    return this.instances;
  }

  public pickFromId(contactRoleId: number): RoleInterface {
    const index = this.getInstances().findIndex(role => role.getRoleId() === contactRoleId);
    
    return this.getInstances()[index];
  }

}

export default new RoleContainer();
